
class PlayerKeyUp {
    
    constructor(key) {
        this.key = key
    }
    
    getType() {
        return 'player_key_up'
    }
    
    getData() {
        return {
            key: this.key
        };
    }
    
}

export default PlayerKeyUp
